export const LOADING_CLIMA_LOG = "LOADING_CLIMA_LOG";
export const GET_CLIMA_LOG = "GET_CLIMA_LOG";
export const CLIMA_LOG_FAIL = "CLIMA_LOG_FAIL";
